import { ICurrency } from "types/payments/Currency";

const CurrencySymbolMapper = {
  AED: "AED",
  CAD: "C$",
  HKD: "HK$",
  AUD: "AU$",
  SGD: "SG$",
} as Record<string, string | undefined>;

export const getCurrencySymbol = (
  selectedCurrency: ICurrency,
  showSymbol = true,
): string => {
  if (!showSymbol) return "";

  return (
    CurrencySymbolMapper[selectedCurrency?.value] || selectedCurrency?.symbol
  );
};
